import React from "react";
import { DownloadSimple } from "phosphor-react";

const DownloadBrochureButton = () => {
  return (
    <div>
      <a
        href="./brochure.pdf"
        download="REMA 2025 Conference Brochure.pdf"
        target="_blank"
        rel="noopener noreferrer"
        className=" flex gap-3 items-center justify-center border border-light-green-500 bg-light-green-500 hover:bg-light-green-600 text-green-800 font-semibold py-3 px-8 transition duration-300 ease-in-out transform text-sm w-full lg:w-fit text-center "
        style={{ whiteSpace: "nowrap" }}
      >
        Download brochure
        <DownloadSimple size={18} />
      </a>
    </div>
  );
};

export default DownloadBrochureButton;
